export const SET_LINK_LOADING = 'SET_LINK_LOADING';
export const SET_LINK_ERROR = 'SET_LINK_ERROR';
export const SET_LINK_RETRIEVING = 'SET_LINK_RETRIEVING';
export const ASSIGN_LINK_FORM = 'ASSIGN_LINK_FORM';
export const CLEAR_LINK_FORM = 'CLEAR_LINK_FORM';
export const VALUES_SUCCESSFULLY_SAVED = 'VALUES_SUCCESSFULLY_SAVED';
export const ASSIGN_LINK_SC = 'ASSIGN_LINK_SC';